import {Localizer} from "../../../infrastructure/localization/localizer";
import {Table} from "@tanstack/react-table";
import {debounce} from "lodash";

type ReactSyncTablePaginationCountProps<T> = {
    table: Table<T>;
    debounceDelay?: number;
}

export const ReactSyncTablePaginationCount = <T, >({table, debounceDelay = 1000}: ReactSyncTablePaginationCountProps<T>) => {
    return (
        <div className="d-flex margin-right-s align-items-center">
            <div className="margin-right-s">
                <strong>
                    {`${Localizer.global_page()} ${table.getState().pagination.pageIndex + 1} ${Localizer.global_af()} `}
                    {table.getPageCount().toLocaleString()}
                </strong>
            </div>
            <div className="margin-right-">
                {Localizer.dashboard_goToPage()}
                <input
                    type="number"
                    min="1"
                    max={table.getPageCount()}
                    defaultValue={table.getState().pagination.pageIndex + 1}
                    onChange={debounce(e => {
                        const page = e.target.value ? Number(e.target.value) - 1 : 0
                        table.setPageIndex(page)
                    }, debounceDelay)}
                    className="border dashboard-card-border-radius rounded margin-left-s"
                />
            </div>
        </div>
    )
}
